export default "__VITE_PUBLIC_ASSET__5cf45152__"